import { useTranslation } from 'react-i18next';
import { BarChart3 } from 'lucide-react';
import { Header } from "@/components/header";
import { Partners } from '@/components/partners';
import { Footer } from '@/components/footer';
import CTA from '@/components/cta';

export default function MonitoringFeature() {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <Header />
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <div className="bg-slate-100 dark:bg-slate-900/30 w-16 h-16 rounded-2xl flex items-center justify-center text-slate-600 dark:text-slate-400">
              <BarChart3 className="w-8 h-8" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white">
              {t('whyChooseUs.features.monitoring.title', 'Advanced Monitoring and Insights')}
            </h1>
          </div>

          <div className="prose prose-slate dark:prose-invert max-w-none">
            <p className="text-xl text-slate-600 dark:text-slate-300 mb-8">
              {t('whyChooseUs.features.monitoring.description', 'Gain real-time visibility with detailed analytics and insights to optimize security operations and response.')}
            </p>

            <div className="mt-12">
              <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">
                {t('whyChooseUs.features.monitoring.subTitle1')}
              </h2>
              <p className="text-lg text-slate-600 dark:text-slate-300 mb-6">
                {t('whyChooseUs.features.monitoring.subTitle1Desc')}
              </p>

              <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">
                {t('whyChooseUs.features.monitoring.subTitle2')}
              </h2>
              <p className="text-lg text-slate-600 dark:text-slate-300 mb-6">
                {t('whyChooseUs.features.monitoring.subTitle2Desc')}
              </p>
              
              <div className="grid md:grid-cols-2 gap-8 mt-12">
                <div className="bg-slate-50 dark:bg-slate-800 p-6 rounded-xl border border-slate-200 dark:border-slate-700">
                  <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-3">
                    {t('whyChooseUs.features.monitoring.benefit1')}
                  </h3>
                  <p className="text-slate-600 dark:text-slate-300">
                    {t('whyChooseUs.features.monitoring.benefit1Desc')}
                  </p>
                </div>
                
                <div className="bg-slate-50 dark:bg-slate-800 p-6 rounded-xl border border-slate-200 dark:border-slate-700">
                  <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-3">
                    {t('whyChooseUs.features.monitoring.benefit2')}
                  </h3>
                  <p className="text-slate-600 dark:text-slate-300">
                    {t('whyChooseUs.features.monitoring.benefit2Desc')}
                  </p>
                </div>
                <div className="bg-slate-50 dark:bg-slate-800 p-6 rounded-xl border border-slate-200 dark:border-slate-700">
                  <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-3">
                    {t('whyChooseUs.features.monitoring.benefit3')}
                  </h3>
                  <p className="text-slate-600 dark:text-slate-300">
                    {t('whyChooseUs.features.monitoring.benefit3Desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CTA />
      <Partners />
      <Footer />
    </div>
  );
}
